import React from 'react'

import Multiline from '../layouts/Multiline.jsx'

import useRequest from '../hooks/useRequest.js'
import { getKECCTrends } from '_services/insights-v2.js'
import { formatKECC } from '../../charts/helpers/formatters.js'

const SeasonalityByCategory = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { data, index } = props
  const { selected_entities, time_frame, time_range, y_labels, title, description } = data

  const kecc = selected_entities.map(({ original_key }) => original_key)

  const { data: response, loading } = useRequest(
    getKECCTrends,
    { audienceId, kecc, keccType: 'categories', timeRange: time_range },
    !!kecc?.length
  )

  const multilineData = formatKECC({
    raw: response,
    names: kecc,
    timeFrame: time_frame,
    type: y_labels,
  })

  const REPLACE_NAMES_MAP = Object.fromEntries(
    selected_entities.map((entity) => [entity.original_key, entity.key])
  )

  return (
    <Multiline
      title={title}
      description={description}
      page={index + 1}
      timeFrame={time_frame}
      isLoading={loading}
      data={multilineData}
      yLabel={y_labels}
      replaceLegend={REPLACE_NAMES_MAP}
    />
  )
}

export default SeasonalityByCategory
